import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import BaseSplashScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseSplashScreenMediator";
import FeedbackPanelView from "./FeedbackPanelView";


export default class SplashLoadScreenMediator extends BaseSplashScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config) {
        super(target, dispatcher, languagePack, layoutManager, startup, soundManager, config);
    }

    initialize() {
        super.initialize();

        this.startFeedback = new FeedbackPanelView(this._target.startFeedback);
        this.startFeedback.setText(this.getText("start.startFeedback"), false, false);
        this.startFeedback.show(false);
        this.anchorObject(this._target.startFeedback, Anchor.B);
    }

    _handleStartButtonClick() {
        this._target.startButton.visible = false;
        this.startFeedback.show(true);
        this.callDelayed(this._start.bind(this), 200);
    }

}